import RadioPartial from './RadioPartial'
import ImageSelectPartial from './ImageSelectPartial'
import BoxSelectPartial from './BoxSelectPartial'
import SliderPartial from './SliderPartial'
import BinaryPartial from './BinaryPartial'
import SelectPartial from './SelectPartial'
import ScrollerPartial from './ScrollerPartial'
import StarPartial from './StarPartial'
import TextResponsePartial from './TextResponsePartial'
import MultiQuestionPartial from './MultiQuestionPartial'
import LongTextBubblePartial from './LongTextBubblePartial'
import DatePartial from './DatePartial'
import UnitPartial from './UnitPartial'
import QueryPartial from './QueryPartial'
import VideoPartial from './VideoPartial'


export default {
	RadioPartial,
	ImageSelectPartial,
	BoxSelectPartial,
	SliderPartial,
	BinaryPartial,
	SelectPartial,
	ScrollerPartial,
	StarPartial,
	TextResponsePartial,
	MultiQuestionPartial,
	LongTextBubblePartial,
	DatePartial,
	UnitPartial,
	QueryPartial,
	VideoPartial
}
